var map = {
	"./fondo/Fondo_Web.svg": "b122",
	"./fondo/Fondo_Web_optimizado.svg": "ed93",
	"./fondo/Fondo_Web_optimoDos.svg": "ad23",
	"./fondo/Fondo_movil_optimo.svg": "bb0e",
	"./fondo/Hoja_Derecha.svg": "d5ef",
	"./fondo/Hoja_Derecha_optima.svg": "d32d",
	"./fondo/Hoja_Izquierda.svg": "7d72",
	"./fondo/Hoja_Izquierda_Optima.svg": "a756",
	"./fondo/Logo_Simple_IBRACO.svg": "741b",
	"./fondo/Logo_Simple_IBRACO_Optimo.svg": "a166",
	"./fondo/Tucan.svg": "2e60",
	"./fondo/Tucan_redondo.svg": "6862",
	"./imagenes_compartidas/ABC.svg": "0c4d",
	"./imagenes_compartidas/Avanzar.svg": "713f",
	"./imagenes_compartidas/Flecha_lado.svg": "4939",
	"./imagenes_compartidas/Flecha_verde_derecha.svg": "af93",
	"./imagenes_compartidas/Flecha_verde_izquierda.svg": "2f16",
	"./imagenes_compartidas/Fondo_Menu_inferior.svg": "8d26",
	"./imagenes_compartidas/Fondo_Menu_inferior_optimo.svg": "6bd0",
	"./imagenes_compartidas/Fondo_Menu_inferior_optimo_alto.svg": "fcc1",
	"./imagenes_compartidas/Fondo_Titulo.svg": "3cea",
	"./imagenes_compartidas/Fondo_Titulo_Optimo.svg": "b316",
	"./imagenes_compartidas/Ginga.svg": "2fce",
	"./imagenes_compartidas/Logo_Completo_IBRACO.svg": "fce9",
	"./imagenes_compartidas/Logo_Simple_IBRACO_aaa.svg": "3bdd",
	"./imagenes_compartidas/Mapa_Vacio_Ids_Optimos.svg": "a047",
	"./imagenes_compartidas/Menu_Interfaz_basica/Abecedario.svg": "1177",
	"./imagenes_compartidas/Menu_Interfaz_basica/Abecedario_activo.svg": "7cf6",
	"./imagenes_compartidas/Menu_Interfaz_basica/Ajustes.svg": "ea93",
	"./imagenes_compartidas/Menu_Interfaz_basica/Ajustes_activo.svg": "76d3",
	"./imagenes_compartidas/Menu_Interfaz_basica/Creditos.svg": "895d",
	"./imagenes_compartidas/Menu_Interfaz_basica/Creditos_activo.svg": "3749",
	"./imagenes_compartidas/Menu_Interfaz_basica/Flecha_abajo.svg": "2ee7",
	"./imagenes_compartidas/Menu_Interfaz_basica/Glosario.svg": "6fc9",
	"./imagenes_compartidas/Menu_Interfaz_basica/Glosario_activo.svg": "11a3",
	"./imagenes_compartidas/Menu_Interfaz_basica/Menu_unidad.svg": "3b21",
	"./imagenes_compartidas/Menu_Interfaz_basica/Menu_unidade_Activo.svg": "791b",
	"./imagenes_compartidas/Presentación_personal.svg": "2892",
	"./imagenes_compartidas/Rectangulo_slider.svg": "ffff",
	"./imagenes_compartidas/Reproducir_sonido_Pequeño.svg": "69a6",
	"./imagenes_compartidas/Voltar.svg": "8448",
	"./imagenes_compartidas/bien.svg": "44a1",
	"./imagenes_compartidas/check.svg": "7b12",
	"./imagenes_compartidas/evaluacion-cerrar-black.svg": "7b0b",
	"./imagenes_compartidas/evaluacion-cerrar.svg": "b492",
	"./imagenes_compartidas/flecha_azul_d.svg": "9683",
	"./imagenes_compartidas/flecha_azul_i.svg": "6216",
	"./imagenes_compartidas/lectura.svg": "b67f",
	"./imagenes_compartidas/mal.svg": "2175",
	"./imagenes_compartidas/modalresult-avanzar.svg": "d3d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d20d";